export const formatThousands = (value: number | string): string => {
  const num = Number(value);
  if (isNaN(num)) return "0";

  // 处理整数情况
  if (Number.isInteger(num)) {
    return num.toLocaleString("en-US");
  }

  // 处理小数情况
  const formatted = num.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return formatted.replace(/\.00$/, "");
};
